import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-refetch'
import { checkNextPropsPromise, connectDefault } from '../utils/utils'
import { talkdesk } from '../utils/Talkdesk'
import { InfoPanel } from './InfoPanel'

import config from '../utils/config';
const talkdeskUrl = config.TALKDESK_INTG_URL;

let redirect_uri = window.location.href.split('/').slice(0, 3).join('/') + '/talkdesk'


export class Talkdesk extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props,context) {
    super(props,context);

    this.state = { }

    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    const talkdesk_installation_id = this.props.location.query.talkdesk_installation_id
    const talkdesk_user_id = this.props.location.query.talkdesk_user_id

    //STEP1
    if ( talkdesk_installation_id !== undefined && talkdesk_user_id !== undefined) {
      talkdesk.setInstallationId(talkdesk_installation_id)
      talkdesk.setUserId(talkdesk_user_id)
      this.setState({talkdesk_installation_id,talkdesk_user_id})

      this.props.fetchOAuth2Details(talkdesk_installation_id)
    }

    //STEP3
    const authCode = this.props.location.query.code
    if ( authCode !== undefined ) {
      this.setState({authCode})
      this.props.fetchToken(talkdesk.getInstallationId(), authCode)
    }
  }

  componentWillReceiveProps(nextProps) {
    //STEP2
    if (checkNextPropsPromise(this.props, nextProps, 'oAuth2Details')) {
      if (nextProps.oAuth2Details.fulfilled){
        const { url, client_id } = nextProps.oAuth2Details.value

        if ( url !== undefined && client_id !== undefined) {
          window.location.href = url+"?client_id="+client_id+"&redirect_uri="+encodeURIComponent(redirect_uri)+"&response_type=code";
        }
        else {
          console.log('Talkdesk: OAuth2 Details do not have url, client_id values')
        }
      }
      else if (nextProps.oAuth2Details.rejected) {
        console.log('Talkdesk: Failed to fetch OAuth2 Details', nextProps)
        this.setState({status: 'failed'})
        talkdesk.setError()
      }
    }

    //STEP4
    else if (checkNextPropsPromise(this.props, nextProps, 'token')) {
      if (nextProps.token.fulfilled){
        const { token } = nextProps.token.value

        if ( token !== undefined) {
          talkdesk.setToken(token)
          this.setState({token})

          this.goBack()
        }
        else {
          this.setState({token:''})
          talkdesk.setError()
        }
      }
      else if (nextProps.token.rejected) {
        console.log('Talkdesk: Failed to fetch token')
        this.setState({token:''})
        talkdesk.setError()
      }
    }
  }

  // Helpers

  goBack() {
    const pathComponents = this.props.location.pathname.split('/');
    pathComponents.splice(pathComponents.length-2, 2);
    const path = pathComponents.join('/')
    this.context.router.push(path);
  }

  renderInfo(title, text) {
    // Have to add a top-level DIV wrapper to adjust for Talkdesk topbar
    return (
      <div className='info-screen'>
        <InfoPanel title={title} text={text} />
      </div>
    )
  }

  render() {
    const { talkdesk_installation_id, talkdesk_user_id, authCode, token, status } = this.state

    // Auth failed
    if ( status === 'failed' ) {
      return this.renderInfo('Unable to login', 'Please contact your account administrator.');
    }
    // Talkdesk Auth successful, but user is not an Admin to access AH console
    else if ( token === '' ) {
      return this.renderInfo('Welcome to AssistHub!', 'Please contact your account administrator to manage the configuration.');
    }
    // Initial entry point from Talkdesk Admin
    else if ( talkdesk_installation_id !== undefined && talkdesk_user_id !== undefined) {
      return null
    }
    // Got AH token
    else if ( token !== undefined) {
      return null
    }
    // Got Talkdesk OAuth code
    else if ( authCode !== undefined) {
      return null
    }
    // No params - just leave this route
    else {
      this.goBack()
      return null
    }
  }
}

export default connect.defaults(connectDefault)(props => {
  return {
    fetchOAuth2Details: (instalationId) => ({
      oAuth2Details: {
        title: 'Fetch Talkdesk OAuth2 Details',
        dispatch: props.dispatch,
        url:`${talkdeskUrl}/installations/${instalationId}/sso`,
    }}),
    fetchToken: (instalationId, authCode) => ({
      token: {
        title: 'Fetch Talkdesk Token',
        dispatch: props.dispatch,
        url:`${talkdeskUrl}/installations/${instalationId}/sso`,
        method: 'POST',
        body: {code: authCode,
               redirect_uri: redirect_uri
        }
    }})
  }})(Talkdesk)



// WEBPACK FOOTER //
// ./src/containers/Talkdesk.js